// this exists so we can remove a lot of boilerplate in the components where we use promises

export default class Deferred {
  constructor() {
    this.promise = new Promise((resolve, reject) => {
      this.reject = reject;
      this.resolve = resolve;
    });
  }
}
